export default __webpack_public_path__ + "static/media/linktree_white.67cd7ce6.svg";